module.exports = __webpack_public_path__ + "static/flatart-insta-ss1-7e66372f429c57405371f89fdb12d459.png";